import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import {
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Drawer,
  IconButton,
  Typography,
  Toolbar,
  Button,
} from "@mui/material";
import withStyles from "@mui/styles/withStyles";
import CloseIcon from "@mui/icons-material/Close";
import useMediaQuery from "@mui/material/useMediaQuery";
import PowerSettingsNewIcon from "@mui/icons-material/PowerSettingsNew";
import classNames from "classnames";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

const styles = (theme) => ({
  closeIcon: {
    marginRight: "auto",
    "& svg": {
      color: theme.palette.primary.main,
    },
  },
  headSection: {
    width: "100%",
    background: theme.palette.common.white,
  },
  blackList: {
    backgroundColor: theme.palette.common.white,
    height: "100%",
    "& svg": {
      color: theme.palette.primary.main,
    },
    "& .Mui-selected": {
      background: theme.palette.primary.main,

      "& h6": {
        color: theme.palette.common.white,
      },

      "& svg": {
        color: "white",
      },
    },
  },
  noDecoration: {
    textDecoration: "none !important",
  },

  ModeToggle: {
    display: "flex",
    justifyContent: "space-between",
    margin: "auto",
    cursor: "pointer",
    alignItems: "center",
    maxWidth: "300px",
    width: "100%",
    background: theme.palette.common.white,
    borderRadius: "48px",
    position: "relative",
    "& .item": {
      padding: theme.spacing(1.5),
      flex: 1,
      textAlign: "center",
      textTransform: "uppercase",
      color: "#64748B",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      width: "75px",
    },
  },

  slider: {
    width: "50%",
    height: "40px",
    background: theme.palette.primary.main,
    opacity: 0.1,
    position: "absolute",
    left: "3px",
    borderRadius: "48px",
    transition: "100ms",
  },

  moved: {
    transform: "translateX(calc(100% - 5px))",
  },

  activeText: {
    color: theme.palette.primary.main,
    "& path": {
      stroke: theme.palette.primary.main,
    },
  },

  rightBtns: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(2),
    flexDirection: "column",
    padding: theme.spacing(2),
  },

  loginBtn: {
    // fontSize: "18px",
    padding: theme.spacing(1, 4),
    borderRadius: "32px",
  },

  itemName: {
    color: theme.palette.common.textAlt,
    "&.active": {
      color: theme.palette.primary.main,
    },
  },

  itemIcon: {
    "& path": {
      stroke: theme.palette.common.textAlt,
    },

    "&.active": {
      "& path": {
        stroke: theme.palette.primary.main,
      },
    },
  },
});

function NavigationDrawer(props) {
  const {
    open,
    onClose,
    anchor,
    classes,
    menuItems,
    location,
    theme,
    handleLogout,
    isAuthenticated,
    themeMode,
    toggleDarkMode,
  } = props;
  const isWidthUpSm = useMediaQuery(theme.breakpoints.up("sm"));
  const hist = useHistory();
  window.onresize = () => {
    if (isWidthUpSm && open) {
      onClose();
    }
  };

  console.log("selected itemm", location);

  return (
    <Drawer variant="temporary" open={open} onClose={onClose} anchor={anchor}>
      <Toolbar className={classes.headSection}>
        <ListItem
          style={{
            paddingTop: theme.spacing(0),
            paddingBottom: theme.spacing(0),
            height: "100%",
            justifyContent: anchor === "left" ? "flex-start" : "flex-end",
          }}
          disableGutters
        >
          <ListItemIcon className={classes.closeIcon}>
            <IconButton
              onClick={onClose}
              aria-label="Close Navigation"
              size="large"
            >
              <CloseIcon color="primary" />
            </IconButton>
          </ListItemIcon>
        </ListItem>
      </Toolbar>
      <List className={classes.blackList}>
        {menuItems.map((element) => {
          const Wrapper = element?.link ? Link : "div";
          const wrapperProps = element?.link ? { to: element.link } : {};

          return (
            <Wrapper
              key={element.name}
              {...wrapperProps}
              className={classes.noDecoration}
              onClick={element?.onClick ? element.onClick : () => onClose()}
            >
              <ListItemButton
                button
                /**
                 * We disable ripple as it will make a weird animation
                 * with primary and primary color
                 */
                disableRipple
                disableTouchRipple
              >
                <ListItemIcon
                  className={classNames(
                    classes.itemIcon,
                    location === element.link && "active"
                  )}
                >
                  {element.icon}
                </ListItemIcon>
                <ListItemText
                  primary={
                    <Typography
                      variant="subtitle1"
                      className={classNames(
                        classes.itemName,
                        location === element.link && "active"
                      )}
                    >
                      {element.name}
                    </Typography>
                  }
                />
              </ListItemButton>
            </Wrapper>
          );
        })}

        <div className={classes.rightBtns}>
          <div onClick={() => toggleDarkMode()} className={classes.ModeToggle}>
            <div className="item">
              <svg
                className={!themeMode ? classes.activeText : ""}
                xmlns="http://www.w3.org/2000/svg"
                width="19"
                height="19"
                viewBox="0 0 19 19"
                fill="none"
              >
                <path
                  d="M9.5 14.375C12.1924 14.375 14.375 12.1924 14.375 9.5C14.375 6.80761 12.1924 4.625 9.5 4.625C6.80761 4.625 4.625 6.80761 4.625 9.5C4.625 12.1924 6.80761 14.375 9.5 14.375Z"
                  stroke="#94A3B8"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M14.855 14.855L14.7575 14.7575M14.7575 4.2425L14.855 4.145L14.7575 4.2425ZM4.145 14.855L4.2425 14.7575L4.145 14.855ZM9.5 2.06V2V2.06ZM9.5 17V16.94V17ZM2.06 9.5H2H2.06ZM17 9.5H16.94H17ZM4.2425 4.2425L4.145 4.145L4.2425 4.2425Z"
                  stroke="#94A3B8"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </div>

            <div className="item">
              <svg
                className={themeMode ? classes.activeText : ""}
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="19"
                viewBox="0 0 18 19"
                fill="none"
              >
                <path
                  d="M1.52232 9.81497C1.79232 13.6775 5.06982 16.82 8.99232 16.9925C11.7598 17.1125 14.2348 15.8225 15.7198 13.79C16.3348 12.9575 16.0048 12.4025 14.9773 12.59C14.4748 12.68 13.9573 12.7175 13.4173 12.695C9.74982 12.545 6.74982 9.47747 6.73482 5.85497C6.72732 4.87997 6.92982 3.95747 7.29732 3.11747C7.70232 2.18747 7.21482 1.74497 6.27732 2.14247C3.30732 3.39497 1.27482 6.38747 1.52232 9.81497Z"
                  stroke="#94A3B8"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </div>

            <div
              className={classNames(classes.slider, themeMode && classes.moved)}
            ></div>
          </div>

          <Button
            fullWidth
            variant="contained"
            className={classes.loginBtn}
            style={{
              padding: "10px 24px",
              cursor: "pointer",
              position: "relative", 
              zIndex: 9999,
              minWidth: "120px",
              minHeight: "44px",
              touchAction: "manipulation"
            }}
            onClick={(e) => {
              e.preventDefault();
              console.log("Drawer login button clicked");
              if (isAuthenticated) {
                handleLogout();
                onClose();
              } else {
                // Direct URL navigation for cross-browser compatibility
                window.location.href = "/auth/login";
              }
            }}
          >
            {isAuthenticated ? "Log Out" : "Join Now"}
          </Button>
        </div>
        {/* <Link
          className={classes.noDecoration}
          onClick={handleLogoutClick}
        >
          <ListItemButton
            button

            disableRipple
            disableTouchRipple
          >
            <ListItemIcon><PowerSettingsNewIcon className="grey" /></ListItemIcon>


            <ListItemText
              primary={
                <Typography variant="subtitle1" color={"primary"}>
                  Logout
                </Typography>
              }
            />
          </ListItemButton>
        </Link> */}
      </List>
    </Drawer>
  );
}

NavigationDrawer.propTypes = {
  anchor: PropTypes.string.isRequired,
  theme: PropTypes.object.isRequired,
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  menuItems: PropTypes.arrayOf(PropTypes.object).isRequired,
  classes: PropTypes.object.isRequired,
  location: PropTypes.string,
};

export default withStyles(styles, { withTheme: true })(NavigationDrawer);
